import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/permissionObjects';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.PERMISSION_OBJECTS);

export const usePermissionObjects = (sessionToken) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(),
        queryFn: async () => {
            const response = await Client.fetchAll(sessionToken);

            if (response && response.length > 0) {
                return response.reduce(
                    (acc, { label, className }) => ({
                        ...acc,
                        [className]: label
                    }),
                    {}
                );
            } else {
                return [];
            }
        },
        onSuccess: (data) => {
            console.log('Fetch permissions objects: Success', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
